import { MFEAddress, ValidationStatus } from './mfe-common.interfaces';

export interface PersonalAddressData {
  personalAddress: {
    streetAddress: MFEAddress;
    mailingAddress: MFEAddress;
  };
}

export interface PersonalAddressGetData {
  personalAddress: IPersonalAddressState;
  validationStatus: ValidationStatus;
}

interface IPersonalAddressState {
  mailingAddress: MFEAddress;
  streetAddress: MFEAddress;
  isStreetAddressSame: boolean;
  validationStatus: string;
  showValidation: boolean;
  clientAddresses: AllClientAddresses;
  isClientAddressesProcessing: boolean;
  isClientAddressesLoaded: boolean;
  mailingAddressDropdown: string;
  streetAddressDropdown: string;
  isContinueConfirmed: boolean;
}

//interfaces below come from VGIM since they were not available in the MFE contracts
interface AllClientAddresses {
  readonly mailingAddressesList: Array<ClientAddress>;
  readonly streetAddressesList: Array<ClientAddress>;
}

interface ClientAddress {
  readonly addressLines: Array<string>;
  readonly countryCode: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly zipPlus4: string;
  readonly isPrimaryAddress: boolean;
  readonly isValidRPO: boolean;
  readonly isValidEscheat: boolean;
  readonly isMilitaryAddress: boolean;
  readonly isForeignAddress: boolean;
  readonly isDefaultMailing?: boolean;
  readonly addressType: string;
  readonly forDisplay: string;
  readonly comparator: string;
  readonly isPrimaryResidence?: boolean;
}
